export default __webpack_public_path__ + "edcf5261462bf887c5d842f2fb8e19db.jpg";